// @owners { team: patient-health }
import { AltoIcon, Description, PressableAltoIcon, Row, XxsSpacing } from '@alto/design-system';
import { type RejectCategoryType } from '@alto/scriptdash/alto/billing/types/v1/reject_category_type';
import React, { useState } from 'react';
import getInsuranceName from '~shared/helpers/insuranceName';
import { type Insurance } from '~shared/types';
import NotCoveredByInsuranceModal from './modals/NotCoveredByInsuranceModal';

export type Props = {
  readonly insurance: Insurance | null | undefined;
  readonly isFertility: boolean;
  readonly reject_category: RejectCategoryType | null | undefined;
};

const NotCoveredByInsuranceInfoRow = ({ insurance, isFertility, reject_category }: Props) => {
  const [isModalShowing, setIsModalShowing] = useState(false);

  const toggleModal = () => {
    setIsModalShowing(!isModalShowing);
  };

  if (!insurance || !reject_category) {
    return null;
  }

  const { primaryName, secondaryName } = getInsuranceName(insurance);
  const insuranceName = secondaryName ? `${primaryName} ${secondaryName}` : primaryName;
  return (
    <div>
      <Row
        rowStart
        centerVertically
      >
        <AltoIcon
          name="shieldslash-small"
          type="grey"
        />
        <XxsSpacing />
        <Description center>Not Covered by {insuranceName}</Description>
        <XxsSpacing />
        <PressableAltoIcon
          name="info-small"
          onPress={toggleModal}
          accessibilityLabel="Press to view why the prescription is not covered by insurance"
        />
      </Row>
      {isModalShowing ? (
        <NotCoveredByInsuranceModal
          onClose={toggleModal}
          isFertility={isFertility}
          insuranceName={insuranceName}
          reject_category={reject_category}
        />
      ) : null}
    </div>
  );
};

export default NotCoveredByInsuranceInfoRow;
